import React from 'react';

import { Popup, Button, Icon } from 'semantic-ui-react';

import PropTypes from 'prop-types';

class ConfirmPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };

    this.confirmed = this.confirmed.bind(this);
    this.canceled = this.canceled.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  confirmed() {
    this.props.onConfirm();
    this.handleClose();
  }

  canceled() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.handleClose();
  }

  render() {
    const { onConfirm, onCancel, children, ...props } = this.props;

    const header = this.props.header || 'Are you sure?';
    const content = (
      <div style={{ marginTop: '8px' }}>
        { this.props.content }
        <div style={{ marginTop: '8px' }}>
          <Button.Group fluid>
            <Button onClick={ this.canceled }><Icon name={this.props.cancelIcon || 'remove circle'} /> { this.props.canceltext || 'No' }</Button>
            <Button primary onClick={ this.confirmed }><Icon name={this.props.okIcon || 'check circle'} /> { this.props.oktext || 'Yes' }</Button>
          </Button.Group>
        </div>
      </div>
    );

    return (
      <Popup id='confirm' onOpen={ this.handleOpen } onClose={ this.handleClose } open={ this.state.open }
        { ...props } header={ header } content={ content } trigger={ this.props.children }
      />
    );
  }
};

ConfirmPopup.propTypes = {
  children: PropTypes.node.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  canceltext: PropTypes.string,
  oktext: PropTypes.string,
  cancelIcon: PropTypes.string,
  okIcon: PropTypes.string,
};

export default ConfirmPopup;
